import React from 'react';
import SlutMap from './SlutMap.js';

const Map = ({lng, lat}) => (
  <div  style={{ display:'block' }} className="br-map">
  <SlutMap
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=AIzaSyA72IjNH9N4YMl5BCQrD0uUPwaP_GxCp18&v=3.exp&libraries=geometry`}
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `0`, overflow: `hidden`, paddingBottom: `100%`, paddingTop: `30px`, position:`relative`}} />}
      mapElement={<div style={{ height: `400px`, width: `400px` }} />}
      lng={lng}
      lat={lat}
    />
  </div>
);

export default Map;
